// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for CatalogManagement and ProductModal */
.CatalogManagement_catalog__ILfa3 {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
  box-sizing: border-box;
  background: #f5f7fa;
}

.CatalogManagement_header__DWuiQ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.CatalogManagement_header__DWuiQ h1 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.CatalogManagement_controls__9XHmy {
  display: flex;
  gap: 0.5rem;
}

.CatalogManagement_controls__9XHmy input {
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 200px;
}

.CatalogManagement_controls__9XHmy button {
  padding: 0.5rem 1rem;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.CatalogManagement_gridSection__pGb7k {
  flex: 1 1;
  overflow-y: auto;
}

.CatalogManagement_grid__HbPB7 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
}

.CatalogManagement_card__H3Cgx {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  padding: 1rem;
  box-sizing: border-box;
  aspect-ratio: 1 / 1;
}

.CatalogManagement_cardHeader__tK2Dv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.CatalogManagement_cardHeader__tK2Dv h2 {
  font-size: 1.1rem;
  margin: 0;
  color: #333;
  word-break: break-word;
}

.CatalogManagement_gtin__S0tUn {
  font-family: monospace;
  font-size: 0.85rem;
  color: #555;
}

.CatalogManagement_cardBody__iIjmo {
  flex: 1 1;
  font-size: 0.9rem;
  color: #444;
  margin-bottom: 0.5rem;
  overflow-y: auto;
}

.CatalogManagement_cardBody__iIjmo p {
  margin-top: 0.5rem;
  color: #666;
  font-size: 0.85rem;
}

.CatalogManagement_cardActions__7UjIo {
  display: flex;
  gap: 0.5rem;
}

.CatalogManagement_cardActions__7UjIo button {
  flex: 1 1;
  padding: 0.4rem;
  font-size: 0.9rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.CatalogManagement_cardActions__7UjIo button:first-child {
  background: #6c757d;
  color: #fff;
}

.CatalogManagement_cardActions__7UjIo button:last-child {
  background: #dc3545;
  color: #fff;
}

/* Modal styles */
.CatalogManagement_modalBackdrop__60eQa {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.CatalogManagement_modal__mZm18 {
  background: #fff;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  width: 90%;
  max-width: 500px;
  box-sizing: border-box;
}

.CatalogManagement_modal__mZm18 h2 {
  margin-top: 0;
  font-size: 1.25rem;
  color: #333;
}

.CatalogManagement_modalForm__U84-r {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
}

.CatalogManagement_modalForm__U84-r input,
.CatalogManagement_modalForm__U84-r select,
.CatalogManagement_modalForm__U84-r textarea {
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
}

.CatalogManagement_sizeGroup__CItDO {
  display: flex;
  gap: 0.5rem;
}

.CatalogManagement_modalActions__vNgQe {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.CatalogManagement_modalActions__vNgQe button {
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.CatalogManagement_modalActions__vNgQe button:first-child {
  background: #007bff;
  color: #fff;
}

.CatalogManagement_modalActions__vNgQe button:last-child {
  background: transparent;
  color: #007bff;
  border: 1px solid #007bff;
}`, "",{"version":3,"sources":["webpack://./src/modules/Developer/TestPages/CatalogManagement/styles/CatalogManagement.module.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uCAAuC;EACvC,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":["/* Styles for CatalogManagement and ProductModal */\r\n.catalog {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  padding: 1rem;\r\n  box-sizing: border-box;\r\n  background: #f5f7fa;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.header h1 {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  color: #333;\r\n}\r\n\r\n.controls {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.controls input {\r\n  padding: 0.5rem 0.75rem;\r\n  font-size: 1rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  width: 200px;\r\n}\r\n\r\n.controls button {\r\n  padding: 0.5rem 1rem;\r\n  background: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.gridSection {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n}\r\n\r\n.grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.card {\r\n  background: #fff;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 1rem;\r\n  box-sizing: border-box;\r\n  aspect-ratio: 1 / 1;\r\n}\r\n\r\n.cardHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.cardHeader h2 {\r\n  font-size: 1.1rem;\r\n  margin: 0;\r\n  color: #333;\r\n  word-break: break-word;\r\n}\r\n\r\n.gtin {\r\n  font-family: monospace;\r\n  font-size: 0.85rem;\r\n  color: #555;\r\n}\r\n\r\n.cardBody {\r\n  flex: 1;\r\n  font-size: 0.9rem;\r\n  color: #444;\r\n  margin-bottom: 0.5rem;\r\n  overflow-y: auto;\r\n}\r\n\r\n.cardBody p {\r\n  margin-top: 0.5rem;\r\n  color: #666;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.cardActions {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.cardActions button {\r\n  flex: 1;\r\n  padding: 0.4rem;\r\n  font-size: 0.9rem;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.cardActions button:first-child {\r\n  background: #6c757d;\r\n  color: #fff;\r\n}\r\n\r\n.cardActions button:last-child {\r\n  background: #dc3545;\r\n  color: #fff;\r\n}\r\n\r\n/* Modal styles */\r\n.modalBackdrop {\r\n  position: fixed;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background: rgba(0,0,0,0.4);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal {\r\n  background: #fff;\r\n  padding: 1.5rem;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n  width: 90%;\r\n  max-width: 500px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.modal h2 {\r\n  margin-top: 0;\r\n  font-size: 1.25rem;\r\n  color: #333;\r\n}\r\n\r\n.modalForm {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.modalForm input,\r\n.modalForm select,\r\n.modalForm textarea {\r\n  padding: 0.5rem;\r\n  font-size: 1rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n}\r\n\r\n.sizeGroup {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.modalActions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.modalActions button {\r\n  padding: 0.5rem 1rem;\r\n  font-size: 1rem;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.modalActions button:first-child {\r\n  background: #007bff;\r\n  color: #fff;\r\n}\r\n\r\n.modalActions button:last-child {\r\n  background: transparent;\r\n  color: #007bff;\r\n  border: 1px solid #007bff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"catalog": `CatalogManagement_catalog__ILfa3`,
	"header": `CatalogManagement_header__DWuiQ`,
	"controls": `CatalogManagement_controls__9XHmy`,
	"gridSection": `CatalogManagement_gridSection__pGb7k`,
	"grid": `CatalogManagement_grid__HbPB7`,
	"card": `CatalogManagement_card__H3Cgx`,
	"cardHeader": `CatalogManagement_cardHeader__tK2Dv`,
	"gtin": `CatalogManagement_gtin__S0tUn`,
	"cardBody": `CatalogManagement_cardBody__iIjmo`,
	"cardActions": `CatalogManagement_cardActions__7UjIo`,
	"modalBackdrop": `CatalogManagement_modalBackdrop__60eQa`,
	"modal": `CatalogManagement_modal__mZm18`,
	"modalForm": `CatalogManagement_modalForm__U84-r`,
	"sizeGroup": `CatalogManagement_sizeGroup__CItDO`,
	"modalActions": `CatalogManagement_modalActions__vNgQe`
};
export default ___CSS_LOADER_EXPORT___;
